var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-main-inner',{attrs:{"title":"基础设置"}},[_c('layout-card-wrap',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"md":6}},[_c('subject-card',{attrs:{"config":_vm.brand}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }